import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store as baseStore } from './core/redux/store';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter as Router, Route, Switch, withRouter } from 'react-router-dom';
import { SecurityProvider } from './libs/security/provider';
import CallbackPage from './libs/security/components/callback';
import SilentCallbackPage from './libs/security/components/silentCallback';
import { LanguageCtxProvider } from './contexts/language.context';
import { userManager } from './core/security/userManger';
import LoadingPage from './components/landingPage/loadingUserPage';
import UnauthenticatedPage from './components/unauthenticatedPage';
import UnauthorizedPage from './components/unauthorizedPage';
import { acceptedRoles } from './core/security/const';
import Logger, { initLogger } from './libs/logger';
//import SeqLogger from './libs/logger/logger.seq';
import ConsoleLogger from './libs/logger/logger.console';
import { isEnvDevelopment, Settings } from './variables';
import { LogArea, MsgInput } from './libs/logger/const';
import './index.css';

//initLogger(SeqLogger, Settings.LOGGER_TYPES, Settings.LOGGER_AREAS, isEnvDevelopment);
initLogger(ConsoleLogger, Settings.LOGGER_TYPES, Settings.LOGGER_AREAS, isEnvDevelopment);

const onLog = (m: MsgInput) => Logger.info(m, LogArea.Security);

export const store = baseStore;

const basepath = process.env.REACT_APP_ROUTER_BASE_PATH;

ReactDOM.render(
  <Router basename={basepath}>
    <Provider store={store}>
      <LanguageCtxProvider>
        <SecurityProvider userManager={userManager}
          onLog={onLog}
          LoadingElement={(<LoadingPage />)}
          UnauthenticatedElement={(<UnauthenticatedPage />)}
          UnauthorizedElement={(<UnauthorizedPage />)}
          DefaultRoles={acceptedRoles}
        >
          <Switch>
            {/* auxiliary pages */}
            <Route
              exact
              path="/signinSilentCallback"
              component={SilentCallbackPage}
            />
            <Route exact path="/callback" component={withRouter(CallbackPage)} />
            <Route>
              <App />
            </Route>
          </Switch>
        </SecurityProvider>
      </LanguageCtxProvider>
    </Provider>
  </Router>,
  document.getElementById('root')
);

serviceWorker.unregister();
